import React, { useState } from "react";
import { Col, Collapse, Row } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import ContactForm from "../components/forms/ContactForm";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faLinkedinIn,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import MetaTags from "react-meta-tags";

function OffersPage() {
  const [searchTerm, setSearchTerm] = useState("");
  const [questionsCollapse, setQuestionsCollapse] = useState([
    false,
    false,
    false,
    false,
    false,
  ]); // Etat initial des collapse

  const questions = [
    {
      question: "SoluSpots, c’est quoi ?",
      answer:
        "SoluSpots est une plateforme innovante qui <strong>simplifie la location de véhicules</strong> et optimise la <strong>gestion de chantiers</strong> dans le secteur du béton. Nous proposons un large choix de <strong>camions malaxeurs</strong> et de <strong>pompes à béton</strong> disponibles à la location, adaptés aux besoins spécifiques de chaque chantier. </br> En facilitant la mise en relation entre les différents acteurs de l'industrie du béton, SoluSpots permet d'accélérer les échanges et d'améliorer la coordination des opérations. Que vous soyez un bétonnier, un transporteur ou un entrepreneur, notre solution vous aide à rendre vos projets plus efficaces et fluides.",
    },
    {
      question: "Comment se connecter sur SoluSpots ?",
      answer:
        "Pour vous connecter sur soluspots.fr, suivez ces étapes simples après avoir confirmé votre inscription :<ul><li>Rendez-vous sur la page d’accueil du site.</li><li>Entrez votre identifiant et votre mot de passe.</li><li>Cliquez sur le bouton Connexion.</li></ul>Astuce : Veillez à ne laisser aucun espace vide lors de l'inscription ou lorsque vous copiez votre identifiant et votre mot de passe.</br>Si vous venez de vous inscrire et que vous n’avez pas encore reçu d’email de confirmation, vous ne pourrez pas accéder à votre compte. Assurez-vous donc de vérifier votre boîte de réception et vos courriers indésirables.",
    },
    {
      question: "Comment modifier les informations de mon compte ?",
      answer:
        ' Connectez-vous et rendez-vous sur votre page "Mon compte" : vous aurez alors la possibilité de mettre à jour les informations communiquées lors de votre inscription.',
    },
    {
      question: "Quels véhicules peuvent être mis en ligne sur SoluSpots ?",
      answer:
        "Les différents types de camion liés au transporteur de béton :<ul><li>les camions malaxeurs,</li><li>les malaxeurs avec tapis,</li><li>les mixopompes,</li><li>les malaxeurs semi-remorques,</li><li>les camions écologiques (électrique/biocarburant/gaz).</li><li>les pompes</li></ul>",
    },
    {
      question: "Existe-t-il une application mobile ?",
      answer:
        "Oui : l’application <strong>SoluSpots</strong> est disponible sur <strong>Google Play et Apple Store</strong>, elle permet aux utilisateurs de s’inscrire, se connecter et de gérer leurs commandes directement depuis un mobile",
    },
    {
      question: "Qu'est ce que la SpotMonnaie ?",
      answer: `
      <p>La <strong>Spotmonnaie</strong> est le système de crédits numériques utilisé sur SoluSpots. Elle permet aux transporteurs de publier leurs disponibilités de camions sur la plateforme ainsi qu’aux bétonniers de publier leurs chantiers.</p>
      <p>Chaque nouvelle inscription donne droit à <strong>cinq crédits gratuits</strong>. Ensuite, les utilisateurs peuvent acheter des packs de Spotmonnaies selon leurs besoins.</p>
      <p><strong>Le principe est simple :</strong></p>
      <ul>
        <li>1 Spotmonnaie = 1 annonce publiée pendant 1 jour.</li>
        <li>Par exemple, avec <strong>5 Spotmonnaies</strong>, vous pouvez publier :
          <ul>
            <li><strong>Une annonce visible 5 jours</strong>, ou</li>
            <li><strong>5 annonces différentes</strong>, chacune valable un jour.</li>
          </ul>
        </li>
      </ul>
      <p>Ce système offre une gestion flexible et transparente des publications, tout en simplifiant les transactions sur la plateforme.</p>
    `,
    },
    {
      question:
        "Quelle est la différence entre un abonnement et un pack Spotmonnaie ?",
      answer: `<p><strong>Sur SoluSpots, vous avez deux options pour publier vos annonces : l’abonnement ou les packs Spotmonnaie.</strong></p>
      <ul>
        <li>L’abonnement vous donne un accès illimité à la publication d’annonces pendant toute la durée de votre engagement (12 ou 24 mois). C’est la solution idéale pour les utilisateurs réguliers qui publient fréquemment.</li>
        <li><strong>Les packs Spotmonnaie, quant à eux, fonctionnent comme des crédits à l’unité.</strong>
          <ul>
            <li>1 Spotmonnaie = 1 annonce pour 1 jour</li>
            <li>Vous achetez un pack de 10, 20 ou 30 Spotmonnaies, selon vos besoins.</li>
            <li>C’est une formule souple et sans engagement, adaptée à une utilisation ponctuelle.</li>
          </ul>
        </li>
      </ul>
      <p><strong>En résumé :</strong></p>
      <ul>
        <li>👉 Abonnement = publications illimitées</li>
        <li>👉 Spotmonnaie = publications à la carte</li>
      </ul>`,
    },
    {
      question: "Comment se passent les paiements ?",
      answer: `<p>Le mode de paiement dépend du type d’achat que vous effectuez.</p>
      <p>Si vous optez pour l’achat de Spotmonnaies, vous pourrez régler directement par carte bancaire.</p>
      <p>En revanche, pour toute souscription à un abonnement, le règlement se fait exclusivement via e-mandat SEPA, un prélèvement automatique sécurisé mis en place en ligne.</p>
      <p><strong>Trouver des infos sur :</strong></p>
      <ul>
        <li>Trouver des contacts, chef d’exploitation, chef de planning, numéro du siège.</li>
      </ul>`,
    },
  ];

  // Filtre selon recherche de mots clés
  const filteredData = questions.filter(
    (item) =>
      item.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.answer.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Collapse ou non une question
  const toggleQuestion = (index) => {
    const updatedCollapseState = [...questionsCollapse];
    updatedCollapseState[index] = !updatedCollapseState[index];
    setQuestionsCollapse(updatedCollapseState);
  };

  return (
    <>
      <MetaTags>
        <title>
          Contactez SoluSpots | Assistance pour transporteurs et bétonniers
        </title>
        <meta
          name="description"
          content="Vous avez des questions sur SoluSpots ? Contactez notre équipe pour obtenir de l'aide sur la gestion de votre compte, vos abonnements ou la mise en ligne de vos annonces. Nous sommes à votre service."
        />
      </MetaTags>

      <div className="container">
        <h1 className="contact-title">
          Bienvenue sur la plateforme SoluSpots <br />
          <span className="contact-title-colored">
            Nous répondons à toutes vos questions
          </span>
        </h1>

        <input
          className="contact-question-faq"
          type="text"
          placeholder="Que recherchez-vous ?"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        {filteredData.map((item, index) => (
          <div key={index}>
            <h2
              onClick={() => toggleQuestion(index)}
              className="contact-question-h2 product-h2-icon"
            >
              {item.question}{" "}
              <span>
                {questionsCollapse[index] ? (
                  <FontAwesomeIcon icon={faChevronUp} />
                ) : (
                  <FontAwesomeIcon icon={faChevronDown} />
                )}
              </span>
            </h2>
            <Collapse in={questionsCollapse[index]}>
              <span dangerouslySetInnerHTML={{ __html: item.answer }} />
            </Collapse>
          </div>
        ))}
      </div>

      <div className="bigcontainer">
        <div className="contact-section-form">
          <Container>
            <Row className="g-4">
              <Col md={12} lg={6} xl={{ span: 5, offset: 1 }}>
                <div className="contact-section-form-content">
                  <h2 className="contact-section-form-content-title">
                    Vous avez une question&nbsp;?
                    <br />
                    <span className="contact-section-form-content-title-colored">
                      Écrivez-nous&nbsp;!
                    </span>
                  </h2>
                  <div className="contact-section-form-content-block">
                    <p className="contact-section-form-content-block-subtitle">
                      Contactez-nous par email à{" "}
                      <a
                        href="mailto: contact@soluspots.fr"
                        className="contact-section-form-content-block-text-email"
                      >
                        contact@soluspots.fr
                      </a>
                    </p>
                  </div>
                  <div className="contact-section-form-content-block">
                    <p className="contact-section-form-content-block-subtitle">
                      Ou appelez-nous au 03 44 71 43 84
                    </p>
                    <p className="contact-section-form-content-block-text">
                      En semaine de 9h à 18h - Appel gratuit
                    </p>
                  </div>
                  <div className="contact-section-form-content-block">
                    <p className="contact-section-form-content-block-subtitle">
                      N’hésitez pas à nous suivre
                      <br />
                      sur les réseaux
                    </p>
                    <p className="contact-section-form-content-block-text">
                      <a
                        href="https://www.facebook.com/profile.php?id=100092581599269"
                        target="_blank"
                        className="contact-section-form-content-block-text-social"
                      >
                        <FontAwesomeIcon icon={faFacebookF} />
                      </a>
                      <a
                        href="https://www.linkedin.com/company/soluspots/"
                        target="_blank"
                        className="contact-section-form-content-block-text-social"
                      >
                        <FontAwesomeIcon icon={faLinkedinIn} />
                      </a>
                      <a
                        href="https://www.youtube.com/@soluspots"
                        target="_blank"
                        className="contact-section-form-content-block-text-social"
                      >
                        <FontAwesomeIcon icon={faYoutube} />
                      </a>
                    </p>
                  </div>
                </div>
              </Col>
              <Col md={12} lg={6} xl={5}>
                <ContactForm></ContactForm>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
}

export default OffersPage;
